import _styled from "@emotion/styled/base";
export var SectionHeader = /*#__PURE__*/_styled("div", true ? {
  target: "em3izsb0"
} : {
  target: "em3izsb0",
  label: "SectionHeader"
})("color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.h4.css;
}, ";", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.h3.css;
}, ";}" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvVGFibGVQcmljaW5nL1NlY3Rpb25IZWFkZXIvU2VjdGlvbkhlYWRlci52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRMkQiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9UYWJsZVByaWNpbmcvU2VjdGlvbkhlYWRlci9TZWN0aW9uSGVhZGVyLnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCB0eXBlIHsgVGhlbWVDb2xvcnMgfSBmcm9tICdAc2VnbWVudC9tYXRjaGEvZm91bmRhdGlvbnMvVGhlbWUnXG5cbmV4cG9ydCBpbnRlcmZhY2UgU2VjdGlvbkhlYWRlclByb3BzIHtcbiAgY29sb3I6IFRoZW1lQ29sb3JzXG59XG5cbmV4cG9ydCBjb25zdCBTZWN0aW9uSGVhZGVyID0gc3R5bGVkLmRpdjxTZWN0aW9uSGVhZGVyUHJvcHM+YFxuICBjb2xvcjogJHsoeyBjb2xvciB9KSA9PiBjb2xvcn07XG5cbiAgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50eXBvZ3JhcGh5Lmg0LmNzc307XG4gICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYnJlYWtwb2ludHMudXAoYHNtYCl9IHtcbiAgICAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnR5cG9ncmFwaHkuaDMuY3NzfTtcbiAgfVxuYFxuIl19 */"));